'use client';

import { ExternalNetworkDangerSettings } from '@terra/ui-design-system';
import { useDeleteExternalNetworkSurface } from '../../../../hooks/api/useSurfaceSettings';
import { useReturnToWelcomeAfterTargetDelete } from '../../target-settings/useReturnToWelcomeAfterTargetDelete';

type ExternalDangerSettingsPanelProps = {
  surfaceId: string;
  surfaceName: string;
};

export function ExternalDangerSettingsPanel({
  surfaceId,
  surfaceName,
}: ExternalDangerSettingsPanelProps) {
  const deleteSurface = useDeleteExternalNetworkSurface();
  const returnToWelcome = useReturnToWelcomeAfterTargetDelete();

  return (
    <ExternalNetworkDangerSettings
      surfaceName={surfaceName}
      isDeleting={deleteSurface.isPending}
      onDelete={async () => {
        await deleteSurface.mutateAsync(surfaceId);
      }}
      onDeleted={returnToWelcome}
    />
  );
}
